import React from 'react'
import Dashboard from '.';

export const dashboardRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
];
